import React from "react";
import { Button, Icon, Table } from "semantic-ui-react";
import useLogin from "@common/components/hooks/useLogin";
import { castCustomerToTable } from "../../helpers/Customer/customers";

/**
 * TableComponent renders a with validation.
 *
 * @typedef {object} InputProps
 * @property {array} rows - The table rows data
 * @property {Function} handleRemove - Function to remove a row from the table
 *
 * @component
 * @param {InputProps} props - The component props.
 * @returns {JSX.Element} The rendered table input field with validation.
 */
export default function TableComponent({
  rows,
  handleRemove,
  handleEdit = null,
  hideName = false,
  showContacts = false,
  nameColumnClassName = "w-25",
  secondColumnName = "Features",
}) {
  const [{ isInReadMode }] = useLogin();

  return (
    <>
      <Table celled structured unstackable className="p-0">
        <Table.Header>
          <Table.Row>
            {!hideName && (
              <Table.HeaderCell collapsing className={nameColumnClassName}>
                Name
              </Table.HeaderCell>
            )}
            <Table.HeaderCell>{secondColumnName}</Table.HeaderCell>
            {showContacts && <Table.HeaderCell>Contact</Table.HeaderCell>}
            <Table.HeaderCell collapsing>&nbsp;</Table.HeaderCell>
            {handleEdit && (
              <Table.HeaderCell collapsing>&nbsp;</Table.HeaderCell>
            )}
          </Table.Row>
        </Table.Header>

        <Table.Body>
          {rows.map((row, index) => {
            const customer = castCustomerToTable(row);
            return (
              <Table.Row key={customer.id ? customer.id : index}>
                {!hideName && (
                  <Table.Cell>
                    <label>{customer.name}</label>
                  </Table.Cell>
                )}
                <Table.Cell>
                  <label>{customer.features}</label>
                </Table.Cell>
                {showContacts && (
                  <Table.Cell>
                    <label>
                      {customer.phone && customer.phone}
                      <span>{` `}</span>
                      {customer.email && customer.email}
                    </label>
                  </Table.Cell>
                )}
                {handleEdit && (
                  <Table.Cell>
                    <Button
                      type="button"
                      icon
                      disabled={isInReadMode}
                      onClick={() => handleEdit({ hideName, customer })}
                    >
                      <Icon name="pencil alternate" color="blue" />
                    </Button>
                  </Table.Cell>
                )}
                <Table.Cell>
                  <Button
                    type="button"
                    icon
                    disabled={isInReadMode}
                    onClick={() => handleRemove(customer)}
                  >
                    <Icon name="cancel" color="red" />
                  </Button>
                </Table.Cell>
              </Table.Row>
            );
          })}
        </Table.Body>
      </Table>
    </>
  );
}
